export default __webpack_public_path__ + "static/ramanSharma2-0fd187e60e275327ef80b7e548ad4d7d.jpg";